import {
  sides,
  trianglePositions,
  popoutPositions,
  openOn,
} from 'shared/constants/popout';


export const sideShape = React.PropTypes.oneOf(_.values(sides));
export const trianglePositionShape = React.PropTypes.oneOf(_.values(trianglePositions));
export const popoutPositionShape = React.PropTypes.oneOf(_.values(popoutPositions));
export const openOnShape = React.PropTypes.oneOf(_.values(openOn));



// WEBPACK FOOTER //
// ./src/shared/shapes/popout.js